import React, {Component} from "react"
import {Row, Col} from "elemental"
import Responsive from "react-responsive"
import shop from "./shop/shop"
import app from "app.controller"
import WordPress from "./WordPress"
import NavigationSidebar from "./components/Navigation/NavigationSidebar"

export default class WordPressContainer extends Component {
  constructor({ slug }) {
    super()
    this.state = {
      slug,
      postType:       "shop",
      content:        {},
      showNavigation: false,
    }
    this.load()
  }

  componentDidMount() {
    app.language.changed.add( this.load )
  }

  componentWillUnmount() {
    app.language.changed.remove( this.load )
  }

  load = () => {
    let slug = this.state.slug
    if ( slug === "startseite" ) {
      shop.getFrontPage()
        .then( page => page.acf )
        .then( content => this.setState( { content, showNavigation: true } ) )
    }

    // if (this.state.postType === "shop") {
    //    shop.getCMSModule(slug).then(content => {
    //       this.setState({content})
    //       console.log(`WordPress::${slug}:received`)
    //    })
    // }
  }

  render() {
    const { content, slug, showNavigation } = this.state
    const extraPaddingStyle           = {
      paddingLeft:  "2rem",
      paddingRight: "2rem"
    }

    return (
      <Row>
        {showNavigation &&
        <Responsive minWidth={992}>
          <Col lg="1/5" className="pt4">
            <h3 className="f3">Marken</h3>
            <NavigationSidebar />
          </Col>
        </Responsive>}

        <Col xs="100%" sm="100%" lg={showNavigation ? "4/5" : "1"} style={showNavigation ? extraPaddingStyle : null }
             className="container cms-wrapper">
          <WordPress page={content} slug={slug}/>
        </Col>
      </Row>
    )
  }
}



// WEBPACK FOOTER //
// ./src/WordPressContainer.js